module.exports = "<% budgets.forEach(function(obj, idx) { %> <li class=ipt_elmList_item> <span class=\"inr ipt_data ipt_chkBoxWrap\"> <input class=forcia-state-count value=\"<%= obj.code %>\" type=checkbox name=budget id=\"dmy_cb_01-<%= idx %>\" <%= obj.chkStatus %> ><label for=\"dmy_cb_01-<%= idx %>\"><%= obj.name %> [<%= obj.count %>件]</label> </span> </li> <% }); %> ";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./web/WEB-INF/js/client/search/templates/budget.template.html
// module id = 66
// module chunks = 2